var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_092_greece",
    "data-name": "092 greece",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(0 0)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223",
    transform: "translate(0.142 0.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M256,126.387h14.273a15.266,15.266,0,0,0-1.66-3.953H256Z",
    transform: "translate(-241.217 -115.187)",
    fill: "#338af3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    d: "M40.985,393.518h18.4a15.116,15.116,0,0,0,3.411-3.953H37.574A15.118,15.118,0,0,0,40.985,393.518Z",
    transform: "translate(-35.404 -366.508)",
    fill: "#338af3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    d: "M40.546,61.939a15.135,15.135,0,0,0-2.972,3.581h2.972Z",
    transform: "translate(-35.404 -58.273)",
    fill: "#338af3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    d: "M14.782,193.17v-3.953H9v3.953H5.142v-3.953H.509a15.6,15.6,0,0,0,0,7.905H29.056a15.528,15.528,0,0,0,.509-3.953Z",
    transform: "translate(0 -178.018)",
    fill: "#338af3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    d: "M161.61,0a14.428,14.428,0,0,0-5.784,1.2V7.247h5.784V3.294h9.2A14.5,14.5,0,0,0,161.61,0Z",
    transform: "translate(-146.828 0)",
    fill: "#338af3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGr);
export default __webpack_public_path__ + "static/media/GR.1f11f93805802e8a1fc031993f751263.svg";
export { ForwardRef as ReactComponent };